import { UEListData } from "@/app/interface/homepage";
import { formatIndianCurrency } from "@/app/utils/helper";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { getUnlistedShareProductPath } from "@/app/unlisted-shares/[...id]/slug";

const ComingSoonCard: React.FC<UEListData> = (card) => {
    // Generate the URL for crawlable links (SEO) — & is normalized to "and"
    const href = getUnlistedShareProductPath(card?.product ?? "", card?.company?.displayName);

    const handleClick = () => {
        setAnalyticsEvent(
            `${process.env.ICM_UE_POST_URL_LISTING}/#/incredmoney-asset/unlistedequities/${card.product}`,
            `US_Listing_page_Coming Soon_${card.product}`
        );
    };

    return (
        <Link href={href} className="block">
            <div className="s flex w-[328px] flex-col gap-s7 rounded-xl border border-black/10 p-s9">
                <div className="flex flex-row gap-s7">
                    <Image
                        src={card?.company?.logoUrl}
                        alt="Logo"
                        objectFit="contain"
                        height={84}
                        width={84}
                        className="w-[84px] h-[84px] rounded-lg"
                    />
                    <div className="flex-1 truncate text-ellipsis">
                        <div className="truncate text-lg font-semibold leading-[23px]">
                            {card?.company?.displayName}
                        </div>
                        <div className="flex items-center text-md font-medium leading-[22px]">
                            {formatIndianCurrency(card?.price?.price)}
                            <span className="text-sm leading-[20px] text-neutral-300">
                                &nbsp;• {card?.minUnits} {card?.minUnits > 1 ? 'shares min' : 'share min'}
                            </span>
                        </div>
                    </div>
                </div>
                <RegularButton
                    noIcon
                    showRightIcon={false}
                    size={ButtonSize.Medium}
                    variant={ButtonVariant.SecondaryDefault}
                    className="w-full max-w-full border-black/10"
                    label="View Details"
                    onClick={handleClick}
                />
            </div>
        </Link>
    );
};

export default ComingSoonCard;